import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import ConsultationDialog from "../common/ConsultationDialog";
import { Toaster } from "sonner";

export const AppLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <WhatsAppFab />
    <ConsultationDialog />
    <Toaster position="top-right" richColors closeButton />
  </div>
);

export default AppLayout;
